export const endpointsApi = (urlApi: string) => ({
	usrCtrl: {
		login: `${urlApi}UsrCtrl/SignIn`,
		passwordReminder: `${urlApi}UsrCtrl/PasswordReminder`,
		getUserById: `${urlApi}UsrCtrl/GetUserById`,
		getUserDtoAltById: `${urlApi}UsrCtrl/GetUserDtoAltById`,
		getUserDtoAltByIdAdmin: `${urlApi}UsrCtrl/GetUserDtoAltByIdAdmin`,
		updateUserDtoAlt: `${urlApi}UsrCtrl/UpdateUserDtoAlt`,
		updateUserDtoAltAdmin: `${urlApi}UsrCtrl/UpdateUserDtoAltAdmin`,
		updatePassword: `${urlApi}UsrCtrl/UpdatePassword`,
		getAllUsersAltByUsrId: `${urlApi}UsrCtrl/GetAllUsersAltByUsrId`,
		addUserDtoAltAdmin: `${urlApi}UsrCtrl/AddUserDtoAltAdmin`,
		addUserDtoAlt: `${urlApi}UsrCtrl/AddUserDtoAlt`,
		delUserDtoAlt: `${urlApi}UsrCtrl/DelUserDtoAlt`,
		inscription: `${urlApi}UsrCtrl/Inscription`,
		validationByUuid: `${urlApi}UsrCtrl/ValidationByUuid`,
		isSuperAdmin: `${urlApi}UsrCtrl/IsSuperAdmin`,
		getAllUsers: `${urlApi}UsrCtrl/GetAllUsers`,
		validateCodeReferer: `${urlApi}UsrCtrl/ValidateCodeReferer`,
	},

	sinCtrl: {
		getSimulationByUsrId: `${urlApi}SinCtrl/GetSimulationByUsrId`,
		getSimulationById: `${urlApi}SinCtrl/GetSimulationById`,
		simulationPieceMinGet: `${urlApi}SinCtrl/{SIM_ID}/SimulationPieceMinGet`,
		simulationPieceMinUpdate: `${urlApi}SinCtrl/SimulationPieceMinUpdate`,
		generateSimulationByParam: `${urlApi}SinCtrl/GenerateSimulationByParam`,
		generationSimulation: `${urlApi}SinCtrl/GenerationSimulation`,
		getSimulationParamsById: `${urlApi}SinCtrl/simulationParametrageGet/{SIN_ID}`,
		setSimulationParamsById: `${urlApi}SinCtrl/simulationParametrageSet/{SIN_ID}`,
		getSimulationEstimation: `${urlApi}SinCtrl/simulationEstimationGet/{SIM_ID}`,
		getSimulationEncart: `${urlApi}SinCtrl/simulationEncartGet/{SIM_ID}`,
		generationSurfaceEtMobilierSimulation: `${urlApi}SinCtrl/GenerationSurfaceEtMobilierSimulation/{SIM_ID}`,
		simulationGetCuisineMtoGet: `${urlApi}SinCtrl/simulationGetCuisineMtoGet/{PIC_ID}/{SCA_ID}`,
		simulationGetCuisineMtoSet: `${urlApi}SinCtrl/simulationGetCuisineMtoSet/{PIC_ID}/{SCA_ID}`,
		sendMailPdfGetById: `${urlApi}SinCtrl/sendMailPdfGet/{SIM_ID}`,
		getEvaluationEnergy: `${urlApi}SinCtrl/GetEvaluationEnergy/{SIM_ID}`,
		getAllSimulationByUsrId: `${urlApi}SinCtrl/GetAllSimulationByUsrId/{usrId}`,
		deleteSimulationById: `${urlApi}SinCtrl/DeleteSimulationById/{itemId}`,
		setParamsEnergetiques: `${urlApi}SinCtrl/SetParamsEnergetiques?SIM_ID={SIM_ID}`,
		getParamsEnergetiques: `${urlApi}SinCtrl/GetParamsEnergetiques?SIM_ID={SIM_ID}`,
		getBatimentSimulationById: `${urlApi}SinCtrl/GetBatimentSimulationById?SIM_ID={SIM_ID}`,
		sendMailPdfPartners: `${urlApi}SinCtrl/sendMailPdfPartners/{SIM_ID}`,
		// simulationPdfGet: `${urlApi}SinCtrl/simulationPdfGet/{SIM_ID}`, // => filesCtrl
	},

	ElmCtrl: {
		getElementsByIdMere: `${urlApi}ElmCtrl/ElementsGet/{CMO_ID_MERE}`,
		getElementsCuisineGet: `${urlApi}ElmCtrl/ElementsCuisineGet/{CMO_ID_MERE}`,
		getMobGroupByScaGet: `${urlApi}ElmCtrl/MobGroupByScaGet/{PIC_ID}`,
		getSrfRfsDmgGet: `${urlApi}ElmCtrl/SrfRfsDmgGet/{PIC_ID}`,
		setMobMobilierSet: `${urlApi}ElmCtrl/MobMobilierSet`,
		setStpStatuePrestaSet: `${urlApi}ElmCtrl/StpStatuePrestaSet`,
		delMobMobilierDel: `${urlApi}ElmCtrl/MobMobilierDel`,
		setDmgModernisationSet: `${urlApi}ElmCtrl/DmgModernisationSet`,
		rfrRefProduitFilter: `${urlApi}ElmCtrl/RfrRefProduitFilter`,
		dmgModernisationDupli: `${urlApi}ElmCtrl/DmgModernisationDupli`,
	},

	orgCtrl: {
		getAllOrganisationsByUsrId: `${urlApi}OrgCtrl/GetAllOrganisationsByUsrId`,
		setOrganisation: `${urlApi}OrgCtrl/SetOrganisation`,
		getOrganisationById: `${urlApi}OrgCtrl/GetOrganisationById`,
		delOrganisation: `${urlApi}OrgCtrl/DelOrganisation`,
	},

	filesCtrl: {
		getPdfFileSimulationById: `${urlApi}SinCtrl/simulationPdfGet/{SIM_ID}`,
	},

	dataRefCtrl: {
		getAllDataRef: `${urlApi}DataRefCtrl/DataRefTabGet/{TabCode}`,
	},

	stripeCtrl: {
		getAllProducts: `${urlApi}StripeCtrl/GetAllProducts`,
		getProductByRefId: `${urlApi}StripeCtrl/GetProductByRefId`,
		checkoutSessionHandler: `${urlApi}StripeCtrl/CheckoutSessionHandler`,
		changeKtvTransationStatus: `${urlApi}StripeCtrl/ChangeKtvTransationStatus`,
		cancelSubscriptionById: `${urlApi}StripeCtrl/CancelSubscriptionById`,
		getFirstSubscription: `${urlApi}StripeCtrl/GetFirstSubscription`,
	},

	cadastreCtrl: {
		jwtTokenValidation: `${urlApi}CadastreCtrl/JwtTokenValidation`,
		checkSubscription: `${urlApi}CadastreCtrl/CheckSubscription`,
	},

	simulationsCtrl: {
		getByUuid: `${urlApi}v2/simulations/{uuid}`,
		changeUser: `${urlApi}v2/simulations/{uuid}/change-user`,
		trialSimulationUsed: `${urlApi}v2/simulations/{SIM_UUID}/trial-used`,
	},

	usersCtrl: {
		getByEmail: `${urlApi}v2/users/by-email?email={email}`,
		create: `${urlApi}v2/users`
	},

});
